// extracted by mini-css-extract-plugin
export default {"boxRegisters":"BoxRegisters_boxRegisters__ESAAW","boxRegistersButtons":"BoxRegisters_boxRegistersButtons__w4acz"};